import endpoints from 'config/endpoints';
import {PERIOD_TYPES} from 'config/constants/period';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE, TRUE_VALUE} from 'util/constants';
import {getColor} from 'util/reports';

const
    name = 'reports',
    createParamsObject = ({period, section, selectedLevel, search, descendants, language}) => {
        const _period = {};

        if (period.type === PERIOD_TYPES.PERIOD_TYPE_MONTH) {
            _period.startDate = period.startDate;
            _period.endDate = period.endDate;
        } else if (period.type === PERIOD_TYPES.PERIOD_TYPE_DATE) {
            _period.startDate = period.date;
            _period.endDate = period.date;
        }

        return {
            ..._period,
            by:          section,
            level:       selectedLevel && selectedLevel.length ? selectedLevel.map(item => typeof item === 'object' ? item.id : item) : undefined,
            descendants: descendants ? TRUE_VALUE : undefined,
            search:      search || undefined,
            language:    language || undefined
        };
    },
    exports = {
        ...storeModuleFactory({
            name,
            endpoint:           endpoints.reports.endpoint,
            timeout:            TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
            transformResultsFn: json => {
                const ret = {
                    ...json,
                    items: [
                        ...json.items.map((item, index) => {
                            const obj = {
                                ...item,
                                section: json.type
                            };


                            return {
                                ...obj,
                                color: getColor(obj, index)
                            };
                        })
                    ]
                };

                return [ret];
            },
            parseParameters: params => ({
                ...params,
                startDate: Math.floor(params.startDate / TIMESTAMP_MULTIPLY),
                endDate:   Math.floor(params.endDate / TIMESTAMP_MULTIPLY),
                level:     params.level ? params.level.join() : undefined,
                language:  params.language ? params.language : undefined
            }),
            filterParamsMap: {
                startDate: 'start_date',
                endDate:   'end_date'
            }
        }),
        createParamsObject
    };


module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/reports.js